import { cartLinesListHeaderStyles } from "@insite/content-library/Components/CartLinesListHeader";
import { css } from "styled-components";

cartLinesListHeaderStyles.wrapper = {
    css: css`
        border: none;
    `,
};

cartLinesListHeaderStyles.checkboxGroup = {
    css: css`
        display: none;
    `,
};

cartLinesListHeaderStyles.productCountText = {
    css: css`
            margin-left: 16px;
            font-family: "Roboto-Bold";
    `,
};
